import { Col, Form, Input, Row } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { EntAnimalBreed } from "../../../../models/handBooks/animalBreed";
import { SelectAnimalType } from "../../../../components/selects";

enum FormField {
    nameKy,
    animalTypeId,
    alias,
    nameRu
}
interface IProps {
    show: boolean;
    animalBreed: EntAnimalBreed;
    onHide: () => void;
    onSubmit: (pos: EntAnimalBreed) => Promise<boolean>;
}

export const AddAnimalBreedModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);


    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);


    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.animalTypeId, value: props.animalBreed.animalType?.id },
            { name: FormField.alias, value: props.animalBreed.alias },
            { name: FormField.nameKy, value: props.animalBreed.nameKy },
            { name: FormField.nameRu, value: props.animalBreed.nameRu },
        ]);
    }

    const setEntityFromFields = (): EntAnimalBreed => {
        let typeAnimal = _.cloneDeep(props.animalBreed);
        typeAnimal.animalTypeId = form.getFieldValue(FormField.animalTypeId);
        typeAnimal.nameKy = form.getFieldValue(FormField.nameKy);
        typeAnimal.nameRu = form.getFieldValue(FormField.nameRu);
        typeAnimal.alias = form.getFieldValue(FormField.alias);
        return typeAnimal;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);

            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={props.animalBreed.id === 0 ? t('handbooks.animal_breeds.add_animal_breeds') : t('handbooks.animal_breeds.edit_animal_breeds')}
                visible={props.show}
                onCancel={props.onHide}
                onSubmit={handleSubmit}
                submitLoading={loading}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Form.Item
                        label={t('general.nameKy')}
                        name={FormField.nameKy}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t('general.nameRu')}
                        name={FormField.nameRu}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t('population.animal_type_population')}
                        name={FormField.animalTypeId}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <SelectAnimalType />
                    </Form.Item>
                </Form>
            </DraggableModal>

        </>

    )
}
